import React, { useEffect } from 'react'

import CheckCircleTwoTone from '@ant-design/icons/CheckCircleTwoTone'
import FlagTwoTone from '@ant-design/icons/FlagTwoTone'
import { Typography, Row, Col } from 'antd'
import { UploadProps } from 'antd/lib/upload'

import { observer } from 'mobx-react-lite'

import { FlexBoxX, FlexBoxY } from 'common/components/boxes'
import Uploader from 'common/components/uploader'
import { formatDateString, formatEnumValue, formatName } from 'common/helpers/formatters'
import { File } from 'common/server/server_types'

import { Delivery } from 'vendor/server/deliveries'

import { ItemTitle } from './item_title'

export interface ReceivingProps {
  delivery: Delivery
  addExistingFiles: (key: string, file: File[] | File) => void
  fileList: (key: string) => UploadProps['fileList']
}

export const Receiving = observer<ReceivingProps>(({ delivery, addExistingFiles, fileList }) => {
  const {
    delivery_issues,
    delivery_issue_type,
    marked_delivered_at,
    marked_delivered_by,
    delivery_issue_resolved_at,
    delivery_issue_resolved_by,
    delivery_files,
  } = delivery

  useEffect(() => {
    addExistingFiles('delivery_files', delivery_files)
  }, [delivery_files])

  const who_marked_delivered =
    marked_delivered_by && formatName(marked_delivered_by.first_name, marked_delivered_by.last_name)

  const who_marked_resolved =
    delivery_issue_resolved_by &&
    formatName(delivery_issue_resolved_by.first_name, delivery_issue_resolved_by.last_name)

  return (
    <>
      <Typography.Paragraph strong>Receiving</Typography.Paragraph>

      <Row gutter={[20, 20]}>
        <Col xs={24} sm={12}>
          <FlexBoxX justifyContent="flex-start" alignItems="flex-start">
            {marked_delivered_at ? (
              `Delivery confirmed on ${formatDateString(marked_delivered_at)} by ${who_marked_delivered}`
            ) : (
              <ItemTitle text="Not logged" />
            )}
          </FlexBoxX>
        </Col>

        <Col xs={24} sm={12}>
          <FlexBoxY justifyContent="flex-start" alignItems="flex-start">
            <ItemTitle text="Issues" />
            {delivery_issue_type ? (
              <span>
                <FlagTwoTone twoToneColor="#eb2f96" style={{ margin: '0 10px' }} />
                {formatEnumValue(delivery_issue_type)}
              </span>
            ) : (
              'No issues'
            )}
          </FlexBoxY>
        </Col>

        {!!delivery_files.length && (
          <Col xs={24} sm={12}>
            <FlexBoxY justifyContent="flex-start" alignItems="flex-start">
              <ItemTitle text="Files" />
              <Uploader
                component="Upload"
                hasCamera
                showPreviewModal
                multiple
                uploadKey={'delivery_files'}
                disabled
                listType="picture-card"
                showDownload
                fileList={fileList('delivery_files')}
              />
            </FlexBoxY>
          </Col>
        )}

        {marked_delivered_at !== null && delivery_issue_type && (
          <Col xs={24} sm={12}>
            <FlexBoxY justifyContent="flex-start" alignItems="flex-start">
              <ItemTitle text="Issue Details" />
              {delivery_issues}
              <FlexBoxX justifyContent="flex-start" alignItems="flex-start" marginTop="15px">
                {delivery_issue_resolved_at && (
                  <span>
                    <CheckCircleTwoTone style={{ marginRight: '10px' }} twoToneColor="#52c41a" />
                    Issue marked resolved on {formatDateString(delivery_issue_resolved_at)} by {who_marked_resolved}
                  </span>
                )}
              </FlexBoxX>
            </FlexBoxY>
          </Col>
        )}
      </Row>
    </>
  )
})
